$(document).ready(function(){
    // appointments modals
    $('#reschedule').on('show.bs.modal', function (e) {
        var modal = $('#reschedule');
        var $invoker = $(e.relatedTarget);
        var id = $invoker.attr('rel');
        if( id ) {
            modal.find('form').attr('action','/appointments/' + 0 );
            modal.find('#modal_appointment_name').text('');
            modal.find('#modal_appointment_attendee_name').text('');
            modal.find('#modal_appointment_date').val('');
            modal.find('#modal_appointment_time').val('');
            modal.find('.btn-primary').prop('disabled',true);
            var json = $.get('/json_appointment/' + id, function( data ) {
                var appt = JSON.parse(data);
                modal.find('form').attr('action','/appointments/' + appt.id );
                modal.find('#modal_appointment_name').text(appt.name);
                modal.find('#modal_appointment_attendee_name').text(appt.attendee);
                modal.find('#modal_appointment_date').val(appt.date);
                modal.find('#modal_appointment_time').val(appt.time);
                modal.find('.btn-primary').prop('disabled',false);
                $('.sirs_datepicker_alt').datepicker({
                  format: "mm/dd/yyyy"
                });
            });
        }
    });
    $('#cancel').on('show.bs.modal', function (e) {
        var $invoker = $(e.relatedTarget);
        var modal = $('#cancel');
        var id = $invoker.attr('rel');
        if( id ) {
            modal.find('form').attr('action','/appointments/' + 0 );
            modal.find('#modal_appointment_name').text('');
            modal.find('#modal_appointment_attendee_name').text('');
            modal.find('#modal_appointment_start').val('');
            modal.find('.btn-primary').prop('disabled',true);
            var json = $.get('/json_appointment/' + id, function( data ) {
                var appt = JSON.parse(data);
                modal.find('form').attr('action','/appointments/' + appt.id );
                modal.find('#modal_appointment_name').text(appt.name);
                modal.find('#modal_appointment_attendee_name').text(appt.attendee);
                modal.find('#modal_appointment_start').text(appt.starts_at_formatted);
                modal.find('.btn-primary').prop('disabled',false);
            });
        }
    });
    $('#missed').on('show.bs.modal', function (e) {
        var $invoker = $(e.relatedTarget);
        var modal = $('#missed');
        var id = $invoker.attr('rel');
        if( id ) {
          modal.find('form').attr('action','/appointments/' + 0 );
          modal.find('#modal_appointment_name').text('');
          modal.find('#modal_appointment_attendee_name').text('');
          modal.find('#modal_appointment_start').val('');
          modal.find('.btn-primary').prop('disabled',true);
          var json = $.get('/json_appointment/' + id, function( data ) {
            var appt = JSON.parse(data);
            modal.find('form').attr('action','/appointments/' + appt.id );
            modal.find('#modal_appointment_name').text(appt.name);
            modal.find('#modal_appointment_attendee_name').text(appt.attendee);
            modal.find('#modal_appointment_start').text(appt.starts_at_formatted);
            modal.find('.btn-primary').prop('disabled',false);
          });
        }
    });
    $('#attended').on('show.bs.modal', function (e) {
        var $invoker = $(e.relatedTarget);
        var modal = $('#attended');
        var id = $invoker.attr('rel');
        if( id ) {
          modal.find('form').attr('action','/appointments/' + 0 );
          modal.find('#modal_appointment_name').text('');
          modal.find('#modal_appointment_attendee_name').text('');
          modal.find('#modal_appointment_start').val('');
          modal.find('.btn-primary').prop('disabled',true);
          var json = $.get('/json_appointment/' + id, function( data ) {
            var appt = JSON.parse(data);
            modal.find('form').attr('action','/appointments/' + appt.id );
            modal.find('#modal_appointment_name').text(appt.name);
            modal.find('#modal_appointment_attendee_name').text(appt.attendee);
            modal.find('#modal_appointment_start').text(appt.starts_at_formatted);
            modal.find('.btn-primary').prop('disabled',false);
          });
        }
    });
});